import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styles from './Layout.module.css';

const Layout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false); // حالة القائمة

  const storedUser = JSON.parse(localStorage.getItem('user') || 'null');
  const userName = storedUser?.name || 'أستاذ حسام';

  const menuItems = [
    { path: '/dashboard', label: 'لوحة التحكم', icon: '📊' },
    { path: '/students', label: 'الطلاب', icon: '👨‍🎓' },
    { path: '/attendance', label: 'الحضور والغياب', icon: '📅' },
    { path: '/groups', label: 'المجموعات', icon: '👥' },
    { path: '/exams', label: 'الامتحانات', icon: '📝' },
    { path: '/grades', label: 'الدرجات', icon: '💯' },
    { path: '/monthly-report', label: 'تقرير الشهر', icon: '📈' },
    { path: '/settings', label: 'الإعدادات', icon: '⚙️' },
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    navigate('/');
  };

  return (
    <div className={styles.layoutWrapper}>

      {/* القائمة الجانبية */}
      <aside className={`${styles.sidebar} ${isMenuOpen ? styles.sidebarOpen : ''}`}>
        <div className={styles.logo}>
          <span>🏛️</span>
        </div>

        <nav>
          {menuItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`${styles.navItem} ${
                location.pathname.includes(item.path) ? styles.activeNavItem : ''
              }`}
              onClick={() => setIsMenuOpen(false)} // غلق القائمة عند الضغط
            >
              <span className={styles.icon}>{item.icon}</span>
              {item.label}
            </Link>
          ))}
        </nav>
      </aside>

      {/* الجزء الأيسر */}
      <main className={styles.mainContent}>
        <header className={styles.header}>
          {/* زر المنيو (يظهر في الموبايل فقط) - بقى جوه الهيدر فوق خالص على اليمين */}
          <button className={styles.menuButton} onClick={() => setIsMenuOpen(!isMenuOpen)}>
            ☰
          </button>
          <div className={styles.headerTitle}></div>
          <div className={styles.profile}>
            <span className={styles.userName}>{userName} 👤</span>
            <button className={styles.logoutBtn} onClick={handleLogout}>
              تسجيل الخروج
            </button>
          </div>
        </header>

        <div className={styles.contentArea}>
          {children}
        </div>
      </main>

      {/* طبقة شفافة خلف القائمة لما تكون مفتوحة على الموبايل، بتقفلها لو ضغطت بره */}
      {isMenuOpen && (
        <div className={styles.overlay} onClick={() => setIsMenuOpen(false)} />
      )}
    </div>
  );
};

export default Layout;